// src/UserContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the shape of your user data
interface User {
  id: number;
  name: string;
  email: string;
  roles: string[];
  features: string[];
}

// Define the context state
interface UserContextType {
  userContext: User | null; // User can be null if not logged in
  setUserContext: (user: User | null) => void; // Function to update the user
}

// Create the context
const UserContext = createContext<UserContextType | undefined>(undefined);

// Create a provider component
const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userContext, setUserContext] = useState<User | null>(null);

  return (
    <UserContext.Provider value={{ userContext, setUserContext }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use the UserContext
const useUserContext = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

export { UserProvider, useUserContext };
